module.exports = __webpack_public_path__ + "static/media/heat-transfer-preset-solarpanels.fb89a087.jpg";